import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { ItemCard } from 'page/catalog/ItemPreviewBasic/ItemCard'
import { itemPreview } from 'page/catalog/store/ItemPreviewStore'
import { useRef } from 'react'
import css from './ItemsPane.module.scss'

export const ItemsPane = observer(() => {
  const { state, items } = itemPreview.it.items
  const ready = state === 'ready'
  const ref = useRef<HTMLDivElement | null>(null)

  const onScroll = useLatestCallback((event: Event) => {
    const pane = event.currentTarget as HTMLDivElement
    const threshold = 200 * 10
    const more = pane.scrollLeft + pane.clientWidth >= pane.scrollWidth - threshold
    if (more) itemPreview.it.items.more()
  })

  const setRef = useLatestCallback((pane: HTMLDivElement | null) => {
    ref.current?.removeEventListener('scroll', onScroll)
    ref.current = pane
    pane?.addEventListener('scroll', onScroll)
  })

  return <Vertical>
    <Space pad={[32, 32, 0, 32]}>
      <Typo size={24} medium upper>
        {i18n('CompleteYourOutfitWithTheseItems')}
      </Typo>
    </Space>
    <Space ref={setRef} className={css.pane}>
      <Space className={css.content} gap={24} center>
        {items.map(it => (<ItemCard key={it.item_id} item={it} />))}
        {!ready && <Space className={css.more}>
          <Typo size={13} upper secondary>
            {i18n('Loading')}
          </Typo>
        </Space>}
      </Space>
    </Space>
  </Vertical>
})
